import { put, call } from 'redux-saga/effects';
import { Types } from './actions';
import ScholarshipsDiscountsRepository from '@/domain/repositories/ScholarshipsDiscountsRepository';
import ScholarshipsDiscountsDataRepository from '@/data/repositories/ScholarshipsDiscountsDataRepository';
import XCheckpointManager from '@/core/managers/xcheckpointManager';

export default function* fetchScholarshipsDiscounts(): any {
  try {
    yield put({ type: Types.GET_SCHOLARSHIPS_DISCOUNTS_REQUEST });
    XCheckpointManager.registerStart('Fetch Scholarships & Discounts');

    const repo: ScholarshipsDiscountsRepository =
      new ScholarshipsDiscountsDataRepository();
    const response = yield call(repo.getScholarshipsDiscounts);

    if (!response) {
      yield put({
        type: Types.GET_SCHOLARSHIPS_DISCOUNTS_FAILURE,
        error: true
      });
      return;
    }

    yield put({
      type: Types.GET_SCHOLARSHIPS_DISCOUNTS_SUCCESS,
      data: response
    });
    XCheckpointManager.registerEnd('Fetch Scholarships & Discounts');
  } catch (error) {
    yield put({
      type: Types.GET_SCHOLARSHIPS_DISCOUNTS_FAILURE,
      error: `Ocurrió un error al obtener becas y descuentos. Detalle: ${
        error instanceof Error ? error.message : String(error)
      }`
    });
  }
}
